import Archive from '@crm/shared/assets/icons/archive.svg?react';
import Calendar from '@crm/shared/assets/icons/calendar-check-out.svg?react';
import Undo from '@crm/shared/assets/icons/undo.svg?react';
import Work from '@crm/shared/assets/icons/work.svg?react';

export const actionsMap = {
    'to_postpone': {
        stile: 'bg-smtr-main-green-10 text-smtr-main-green-100 hover:bg-smtr-main-green-10 hover:text-smtr-main-green-100',
        titleKey: 'crm.common.actions.postponeDeal',
        icon: Calendar,
    },
    'to_lost': {
        stile: 'text-smtr-main-tertiary-100 hover:bg-neutral-100 bg-neutral-100 hover:text-smtr-main-tertiary-100',
        titleKey: 'crm.common.actions.markLost',
        icon: Archive,
    },
    'to_complete': {
        stile: 'text-smtr-main-accent-100 hover:bg-smtr-main-accent-50 bg-smtr-main-accent-50 hover:text-smtr-main-accent-100',
        titleKey: 'crm.common.actions.completeDeal',
        icon: Work,
    },
    'to_board': {
        stile: 'text-blue-500 hover:bg-blue-50 bg-blue-50 w-full border-none',
        titleKey: 'crm.common.actions.returnToPipeline',
        icon: Undo,
    },
};
